import React from 'react';
import { bulkDownload, getTypeLabel, getLanguageLabel } from '../../tools';
import { TranscriptCheckbox } from '../transcriptCheckbox';
import '../../flags.css';

export function Post(props) {
	const post = props.post;

	const hasMoreInfo = () => {
		return post.post_excerpt_stackable_v2 !== '';
	};

	const isCompulsory = () => {
		return post.acf.is_compulsory ?? false;
	};

	const isSelected = () => {
		return props.downloadPostList.includes(post.id);
	};

	const handleBulkDownloadToggle = (event) => {
		props.toggleDownloadPost(post, event.target.checked);
	};

	const handleDownload = (event) => {
		// NOTE most download logic still in employee-comms.js
		if ( post.acf.transcript_file ) {
			const attachTranscript = document.getElementById('transcript-' + post.id);
			if ( attachTranscript && attachTranscript.checked ) {
				event.preventDefault();
				const fileIds = [post.id, Number(attachTranscript.value)];
				bulkDownload(fileIds);
			}
		}
	}

	let className = 'employee-comms-results-documents container';
	if (isSelected()) {
		className += ' selected';
	}

	const createMarkup = (html) => {
		return { __html: html };
	};

	return (
		<div className={className}>
			<div className="row flex-column-reverse flex-md-row">
				<div className="d-flex col-md-10 col-sm-12 pl-2">
					{/* col-md-1 col-sm-4 col-xs-12 */}
					<div className="no-padding-left pl-0 document-actions">
						<div className="content">
							<input
								type="checkbox"
								id={props.topic + '--doc' + post.id}
								value={post.id}
								key={post.topic + '--' + post.id + isSelected()}
								className="multi-download-check employee-comms-checkbox"
								defaultChecked={isSelected()}
								onChange={handleBulkDownloadToggle}
							/>
							<label htmlFor={props.topic + '--doc' + post.id}><span className="screen-reader-text">Add to bulk download</span></label>
						</div>
					</div>
					{/* col-md-11 col-sm-8 col-xs-12 */}
					<div className="no-padding-right no-padding-left w-100">
						<div className="primary-document--info">

							{hasMoreInfo() ? (
								<>
									<h3 className="btn-moreinfo h6"
										id={props.topic + "--headinginfo-" + post.id}
										data-bs-toggle="collapse"
										data-bs-target={'#' + props.topic + '--moreinfo-' + post.id}
										aria-controls={props.topic + "--moreinfo-" + post.id}
									>
										<span dangerouslySetInnerHTML={createMarkup(post.title.rendered)} />

									</h3>

									<div
										id={props.topic + "--moreinfo-" + post.id}
										className="collapse" aria-labelledby={"headinginfo-" + post.id}
									>
										<div className="primary-document--more-info" dangerouslySetInnerHTML={createMarkup(post.content.rendered)} />
									</div>

									{/* <div
										id={"moreinfo-" + post.id}
										className="primary-document--more-info accordion-collapse collapse"
										aria-labelledby={"headinginfo-" + post.id}
									>
										<div>
											{(post.post_excerpt_stackable_v2)}
										</div>
									</div> */}
								</>
							) : (
								<h3 className='h6'>
									{post.title.rendered}
								</h3>
							)}
							{post.acf.download_file_url && (
								<>
									<p className="primary-document--meta">{post.acf.download_file_format && '[' + post.acf.download_file_format.toUpperCase() + ']'} {post.acf.download_file_size}</p>
									<div className="d-flex flex-column flex-md-row">
										<a
											href={post.acf.download_file_url + '?' + Date.now()}
											rel="noreferrer"
											target="_blank"
											className="btn btn-primary download"
											onClick={handleDownload}
											download>Download</a>
										<TranscriptCheckbox post={post} />
									</div>
								</>
							)}
							{post.acf.download_files && (
								<p className='mt-3 d-flex flex-wrap'>Alternative languages:&nbsp;
									{post.acf.download_files.map((file, i, files) => (
										<React.Fragment key={i}>
											<a
												href={file.download_file_url + '?' + Date.now()}
												rel="noreferrer"
												target="_blank"
												download>
												{/* {file.icon_url && (
													<img src={file.icon_url} alt="" loading="lazy" className='primary-document--custom-icon' />
												)} */}
												<i className={`primary-document--custom-icon ${file.language}-flag`}></i>
												{getLanguageLabel(file.language)}
											</a>
											{i + 1 === files.length ? '.' : ', '}
										</React.Fragment>
									))}
								</p>
							)}
						</div>
					</div>
				</div>
				<div className="col-md-2 primary-document-tags">
					{isCompulsory() && (
						<div className="doc-type-pill--compulsory doc-type-pill">Compulsory</div>
					)}
					<div className={'doc-type-pill--' + post.acf.document_type + ' doc-type-pill'}>{getTypeLabel(post.acf.document_type)}</div>
				</div>
			</div>
		</div>
	);
};
export default Post;
